import { useCallback } from 'react';
import type { MultiLang } from '../config';
import Functions from '../functions';
import ItemUtil, { type SearchCallbackFunc, type SortCondition } from './lib/ItemUtil';
import XoonipsListItem from './lib/XoonipsListItem';

interface Props {
    lang: MultiLang;
    itemType: string;
    itemSubType: string;
}

const XoonipsSearchByItemType = (props: Props) => {
    const { lang, itemType, itemSubType: subItemType } = props;

    const searchFunc = useCallback(
        (condition: SortCondition, func: SearchCallbackFunc) => {
            if (itemType === '') {
                func({ total: 0, data: [] });
            } else {
                ItemUtil.getListByItemType(itemType, subItemType, condition, func);
            }
        },
        [itemType, subItemType]
    );

    const baseUrl = ItemUtil.getItemTypeSearchUrl(itemType, subItemType);
    return (
        <div className="list">
            <h3>{Functions.mlang('[en]Listing item[/en][ja]アイテム一覧[/ja]', lang)}</h3>
            <XoonipsListItem lang={lang} url={baseUrl} search={searchFunc} />
        </div>
    );
};

export default XoonipsSearchByItemType;
